import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import SectorPage from "@/pages/SectorPage";
import ContactPage from "@/pages/ContactPage";
import { initLenis, getLenis } from "@/lib/lenis";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = getLenis();
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 80;
        if (lenis) lenis.scrollTo(y);
        else window.scrollTo(0, y);
        return;
      }
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  // Single source of truth for same-page anchor scrolling:
  // prevent the browser's native jump, let Lenis animate once.
  useEffect(() => {
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (!hash || hash.length < 2) return;
      const el = document.querySelector(hash);
      if (!el) return;
      e.preventDefault();
      // Absolute numeric target: immune to any desync between Lenis'
      // internal animatedScroll and the real window.scrollY.
      const y = el.getBoundingClientRect().top + window.scrollY - 80;
      const lenis = getLenis();
      if (lenis) lenis.scrollTo(y);
      else window.scrollTo({ top: y, behavior: "smooth" });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/:slug" element={<SectorPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
